// @ts-check
import React from 'react';

/** @typedef {{
  status?: { errors?: { key: string; message: string }[] };
}} StatusErrorsProps */

/** @type { React.FC<StatusErrorsProps> } */
export const FormStatusErrors = ({ status }) =>
  status && status.errors ? (
    <div className="text-center">
      {status.errors.map((error) => (
        <p
          className="mb-2 text-red-500 capitalize"
          key={`${error.key}${error.message}`}
        >
          {error.key ? `${error.key} ${error.message}` : error.message}
        </p>
      ))}
    </div>
  ) : null;
